import ModalServicesListContainer from './ModalServicesListContainer';

export default ModalServicesListContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/ModalServicesList/index.js